import React, { useEffect, useState } from 'react';
import RModal from '../../../../components/Rsuite/Modal';
import api from '../../../../services/api';
import { useAuth } from '../../../../hooks/auth';
import { CustomInput } from '../../../../components/CustomInput';
import { Label } from '../../../../components/Label';
import { CustomButton } from '../../../../components/CustomButton';
import { Spacer } from '../../../../components/Spacer';
import * as S from './styles';
import { LoadingSpinner } from '../../../../components/LoadingSpinner';

export function CopyModal({ product, open, onClose, listarMontagensProduto }) {
  const { id_empresa } = useAuth();
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedProduct, setSelectedProduct] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const filteredProducts = products.filter(
    (p) =>
      p.Id !== product.Id &&
      String(p.Descricao).toLowerCase().includes(search.toLowerCase()),
  );

  function handleSelectProduct(currProduct) {
    if (selectedProduct?.Id === currProduct.Id) {
      setSelectedProduct({});
      return;
    }

    setSelectedProduct(currProduct);
  }

  async function handleSave() {
    try {
      const copyRequestData = {
        companyId: id_empresa,
        copyProductId: selectedProduct?.Id,
        productId: product.Id,
      };
      const response = await api.post(
        '/produto-montagens/copiar',
        copyRequestData,
      );

      if (response.status === 201) {
        listarMontagensProduto();
        onClose();
      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    api
      .get(`/produto/listarProdutosComMontagem/${id_empresa}`)
      .then((response) => {
        if (response.status === 200) {
          setProducts(response.data);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <RModal
      open={open}
      onClose={onClose}
      title="Copiar Montagens"
      size="lg"
      footer={
        <CustomButton onClick={handleSave} disabled={!selectedProduct?.Id}>
          Salvar
        </CustomButton>
      }
    >
      {isLoading ? (
        <>
          <Spacer y={36} />
          <div
            style={{ display: 'flex', width: '100%', justifyContent: 'center' }}
          >
            <LoadingSpinner size={48} borderSize={6} />
          </div>
          <Spacer y={36} />
        </>
      ) : (
        <>
          <Label htmlFor="search">Pesquisar</Label>
          <CustomInput
            id="search"
            placeholder="pesquisar..."
            value={search}
            onChange={setSearch}
          />

          <Spacer y={20} />

          <S.ProductsWrapper>
            {filteredProducts.map((product) => (
              <S.ProductCard>
                <Label>{product?.Descricao}</Label>
                <Spacer x={12} />
                <CustomButton
                  onClick={() => handleSelectProduct(product)}
                  disabled={
                    !!selectedProduct.Id && selectedProduct.Id !== product.Id
                  }
                >
                  {selectedProduct?.Id === product.Id
                    ? 'Selecionado'
                    : 'Selecionar'}
                </CustomButton>
              </S.ProductCard>
            ))}
          </S.ProductsWrapper>

          <Spacer y={20} />
        </>
      )}
    </RModal>
  );
}
